<template>
	<!-- 资质申请--申请详情 -->
	<div class="qunit-detils">
		<el-breadcrumb separator-class="el-icon-arrow-right">
			<el-breadcrumb-item :to="{ path: '/Qapplication' }">资质申请</el-breadcrumb-item>
			<el-breadcrumb-item>申请详情</el-breadcrumb-item>
		</el-breadcrumb>
		<div class="head">
			<div class="head-column">
				<div class="head-column-item">
					<div class="oval-16"></div>
					<div class="text-title">待受理</div>
					<div class="text-info">
						<div class="time">
							2018-09-26 16:30:58</div>
						<div class="name">中富华商(北京)企业管理有限公司</div>
						<div class="text">提交的
							<span>军工资质证书2级</span>
							材料
						</div>
						<div class="status">进入 <span>待受理</span></div>
					</div>
				</div>
				<div class="line"></div>
				<div class="head-column-item">
					<div class="oval-16 "></div>
					<div class="text-title">材料接收</div>
					<div class="text-info">
						<div class="time"><span>张三</span> 2018-09-26 16:30:58 审批了</div>
						<div class="name">中富华商(北京)企业管理有限公司</div>
						<div class="text">提交的
							<span>军工资质证书2级</span>
							材料
						</div>
						<div class="status">进入 <span>待受理</span></div>
					</div>
				</div>
				<div class="line"></div>
				<div class="head-column-item">
					<div class="oval-16 "></div>
					<div class="text-title">申请</div>
					<div class="text-info">
						<div class="time"><span>张三</span> 2018-09-26 16:30:58 登记了</div>
						<div class="name">中富华商(北京)企业管理有限公司</div>
						<div class="text">提交的
							<span>军工资质证书2级</span>
							材料
						</div>
						<!-- <div class="status">进入 <span>待受理</span></div> -->
					</div>
				</div>
			</div>
			<div class="head-content">
				<div class="head-content-top">
					<el-descriptions>
						<el-descriptions-item label="当前状态">
							<span class="descriptions_status">待受理</span>
						</el-descriptions-item>
					</el-descriptions>
				</div>
				<div class="head-descriptions">
					<el-descriptions>
						<el-descriptions-item label="申请类型">新办申请</el-descriptions-item>
						<el-descriptions-item label="单位名称">
							中富华商(北京)企业管理有限公司
						</el-descriptions-item>
						<el-descriptions-item label="统一社会信用代码">6211241936092580</el-descriptions-item>
						<el-descriptions-item label="资质名称">军工资质</el-descriptions-item>
						<el-descriptions-item label="法定代表人">钱佳艺</el-descriptions-item>
						<el-descriptions-item label="联系人">赵汝杰</el-descriptions-item>
						<el-descriptions-item label="资质等级">乙级</el-descriptions-item>
						<el-descriptions-item label="单位性质">私营企业</el-descriptions-item>
						<el-descriptions-item label="座机号码">
							0449-7473575
						</el-descriptions-item>
						<el-descriptions-item label="申请时间">
							2022-09-01
						</el-descriptions-item>
					</el-descriptions>

				</div>
			</div>
		</div>
		<div class="main">
			<div class="main-title">审查表
				<el-button type="primary" icon="el-icon-upload" class="btn btn-plus" @click="confirmDerive">
					导出
				</el-button>
			</div>
			<el-tabs v-model="activeName">
				<el-tab-pane label="材料接收审查表" name="1">
					<div class="pane-titlt">
						<el-descriptions>
							<el-descriptions-item label="当前数据由">
								张三 <span class="time">2022-09-02 00:46:49</span> 填写
							</el-descriptions-item>
							<el-descriptions-item label="申请单位">
								中富华商(北京)企业管理有限公司
							</el-descriptions-item>
							<el-descriptions-item label="编号">2022001</el-descriptions-item>
						</el-descriptions>
					</div>
					<div class="pane-content">
						<div class="content-item" v-for="(item,index) in list">
							<div class="item-title">{{item.title}}</div>
							<div class="item-cont" v-for="(i,ix) in item.children">
								<div :style="{width:(i.options ? '35%':'calc(100% - 500px)')}">{{i.title}}</div>

								<div style="width: 25%;" v-if="i.options">
									<el-radio-group v-model="i.optionValue" v-if="typeof(i.optionValue)=='string'">
										<el-radio :label="r" v-for="(r,ri) in i.options">{{r}}</el-radio>
									</el-radio-group>
									<el-checkbox-group v-model="i.optionValue" v-if="typeof(i.optionValue)=='object'">
										<el-checkbox :label="r" v-for="(r,ri) in i.options"></el-checkbox>
									</el-checkbox-group>
								</div>
								<div class="cont-right">
									<div class="right-item" :class="{'conform ':i.isActive==0}" @click="checkItem(i,0)">
										符合要求
										<img class="checkImg" v-if="i.isActive==0" src="@/assets/images/11639@3x.png"
											alt="">
									</div>
									<div class="right-item" :class="{'unConform':i.isActive==1}"
										@click="checkItem(i,1)">不符合要求
										<img class="checkImg" v-if="i.isActive==1" src="@/assets/images/21639@3x.png"
											alt="">
									</div>
									<el-input v-model="i.value" placeholder="请输入备注信息"></el-input>
								</div>
							</div>
						</div>
						<div class="conclusion">审核结论
							<div class="conclusion-box">
								<div>材料完整</div>
								<div>退回补充材料</div>
							</div>
						</div>
					</div>
				</el-tab-pane>
				<el-tab-pane label="材料受理审查表" name="2">年度自检报告</el-tab-pane>
				<el-tab-pane label="材料书面审查表" name="3">材料书面审查表</el-tab-pane>

			</el-tabs>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				activeName: '1',
				input: '',
				isActive: 1,
				tableData: [{
						num: '初次',
						name: '系统集成',
						grade: '甲级',
						type: '总体集成',
						time: '2022-08-23 05:21:19',
						person: '郑哲携',
						state: '材料不齐全',
						time1: '2022-08-23 05:21:19',
						person1: '郑哲携',
						reason: '疫情已到尾声？这5件事提醒我们，还没有到胜利的时候',
						time2: '12天 12小时 32分',
					},
					{
						num: '初次',
						name: '系统集成',
						grade: '甲级',
						type: '总体集成',
						time: '2022-08-23 05:21:19',
						person: '郑哲携',
						state: '材料不齐全',
						time1: '2022-08-23 05:21:19',
						person1: '郑哲携',
						reason: '疫情已到尾声？这5件事提醒我们，还没有到胜利的时候',
						time2: '12天 12小时 32分',
					},
				],
				list: [{
						title: '一、申请材料的装订',
						children: [{
								title: '1. 3份纸质（含1份原件）每份盖骑缝章，1份电子版光盘',
								isActive: null,
								value: ''
							},
							{
								title: '2. A4 纸打印或复印，页码编排齐全、无缺号或跳号',
								isActive: null,
								value: ''
							}
						]
					},
					{
						title: '二、申请材料的装订',
						children: [{
								title: '1. 3份纸质（含1份原件）每份盖骑缝章，1份电子版光盘',
								isActive: null,
								value: ''
							},
							{
								title: '2. A4 纸打印或复印，页码编排齐全、无缺号或跳号',
								isActive: null,
								value: ''
							}, {
								title: '3. 3份纸质（含1份原件）每份盖骑缝章，1份电子版光盘',
								isActive: null,
								value: ''
							},
							{
								title: '4. A4 纸打印或复印，页码编排齐全、无缺号或跳号',
								isActive: null,
								value: ''
							}
						]
					},
					{
						title: '三、申请材料的装订',
						children: [{
								title: '1. 3份纸质（含1份原件）每份盖骑缝章，1份电子版光盘',
								isActive: null,
								value: ''
							},
							{
								title: '2. A4 纸打印或复印，页码编排齐全、无缺号或跳号',
								isActive: null,
								value: ''
							}, {
								title: '3. 3份纸质（含1份原件）每份盖骑缝章，1份电子版光盘',
								isActive: null,
								value: '',
								options: ['军队受理点', '军工集团'],
								optionValue: ''
							},
							{
								title: '4. A4 纸打印或复印，页码编排齐全、无缺号或跳号',
								isActive: null,
								value: '',
								options: ['军队受理点'],
								optionValue: []
							}, {
								title: '5. 3份纸质（含1份原件）每份盖骑缝章，1份电子版光盘',
								isActive: null,
								value: '',
								options: ['军队受理点'],
								optionValue: []
							},
							{
								title: '6. A4 纸打印或复印，页码编排齐全、无缺号或跳号',
								isActive: null,
								value: '',
								options: ['军队受理点'],
								optionValue: []
							}, {
								title: '7. 3份纸质（含1份原件）每份盖骑缝章，1份电子版光盘',
								isActive: null,
								value: ''
							}
						]
					},
					{
						title: '四、申请材料的装订',
						children: [{
								title: '1. 3份纸质（含1份原件）每份盖骑缝章，1份电子版光盘',
								isActive: null,
								value: ''
							},
							{
								title: '2. A4 纸打印或复印，页码编排齐全、无缺号或跳号',
								isActive: null,
								value: ''
							}, {
								title: '3. 3份纸质（含1份原件）每份盖骑缝章，1份电子版光盘',
								isActive: null,
								value: '',
								options: ['军队受理点', '军工集团'],
								optionValue: ''
							},
							{
								title: '4. A4 纸打印或复印，页码编排齐全、无缺号或跳号',
								isActive: null,
								value: '',
								options: ['军队受理点'],
								optionValue: []
							}, {
								title: '5. 3份纸质（含1份原件）每份盖骑缝章，1份电子版光盘',
								isActive: null,
								value: '',
								options: ['军队受理点'],
								optionValue: []
							},
							{
								title: '6. A4 纸打印或复印，页码编排齐全、无缺号或跳号',
								isActive: null,
								value: '',
								options: ['军队受理点'],
								optionValue: []
							}, {
								title: '7. 3份纸质（含1份原件）每份盖骑缝章，1份电子版光盘',
								isActive: null,
								value: ''
							}
						]
					}
				]
			}
		},
		methods: {
			checkItem(i, val) {
				if (i.isActive == val) {
					i.isActive = null
				} else {
					i.isActive = val
				}

			}
		}
	}
</script>

<style lang="scss" scoped>
	/deep/ .el-descriptions__body {
		background-color: transparent;
	}

	/deep/ .el-descriptions-item__container {
		span {
			font-family: Microsoft YaHei;
			font-size: 14px;
			font-weight: normal;
			font-stretch: normal;
			line-height: 32px;
			letter-spacing: 0px;
		}
	}

	/deep/ .el-descriptions-item__content {
		color: #545454;
	}

	/deep/ .el-descriptions-item__label {
		color: #9699a0;
	}

	/deep/ .el-table__row .cell {
		font-family: Microsoft YaHei;
		font-size: 16px;
		font-weight: normal;
		font-stretch: normal;
		line-height: 19px;
		letter-spacing: 0px;
		color: #24262b;
	}

	.qunit-detils {
		padding: 20px;
	}

	.head {
		// height: 494px;
		width: 100%;
		background-color: #ffffff;
		box-shadow: 0px 12px 23px 0px rgba(0, 0, 0, 0.05);
		border-radius: 16px;
		margin-top: 23px;
		overflow: hidden;
		padding: 24px;
		box-sizing: border-box;

		.head-column {
			// width: 432px;
			height: 100px;
			display: flex;

			.head-column-item {
				width: 150px;
				height: 100px;

				.text-title {
					width: 96px;
					height: 21px;
					font-family: Microsoft YaHei;
					font-size: 16px;
					font-weight: normal;
					font-stretch: normal;
					line-height: 19px;
					letter-spacing: 0px;
					color: #0147eb;
					margin-left: 16px;
					display: inline-block;
				}

				.text-info {
					width: 250px;
					font-family: Microsoft YaHei;
					font-size: 12px;
					font-weight: normal;
					font-stretch: normal;
					line-height: 19px;
					letter-spacing: 0px;
					color: #9699a0;
					margin-left: 28px;
					margin-top: 8px;

					.time {
						font-size: 12px;
						color: #9699a0;

						span {
							color: #24262b;
						}
					}

					.name {
						font-size: 16px;
						line-height: 25px;
						color: #24262b;
					}

					.text {
						font-size: 12px;
						line-height: 20px;
						color: #545454;

						span {

							font-weight: bold;
							color: #0147eb;
						}
					}

					.status {
						font-size: 12px;
						color: #545454;

						span {
							color: #0147eb;
						}
					}
				}
			}

			.line {
				width: 226px;
				height: 0px;
				border: solid 1px #c4c4c4;
				margin-left: -9px;
				margin-top: 11px;
				margin-right: 6px;
			}
		}

		.head-content {
			// width: 1592px;
			// height: 342px;
			background-color: #f5f6fa;
			border-radius: 8px;
			margin-top: 30px;
			overflow: hidden;

			.head-content-top {
				display: flex;
				margin-top: 32px;
				margin-left: 40px;

				.descriptions_status {
					font-size: 20px;
					font-weight: bold;
					color: #f7931a;
				}
			}

			.img {
				width: 80px;
				height: 80px;
				background-size: 100%;
			}

			.content-title {
				// width: 600px;
				// height: 64px;
				margin-left: 30px;
				margin-top: 8px;

				.title {
					width: 323px;
					height: 34px;
					font-family: Microsoft YaHei;
					font-size: 20px;
					font-weight: normal;
					font-stretch: normal;
					line-height: 24px;
					letter-spacing: 0px;
					color: #24262b;
				}

				.tag {
					margin-top: 6px;

					.tag-item {
						border-radius: 4px;
						display: inline-block;
						margin-right: 8px;

						&:last-child {
							margin-right: 0;
						}
					}

					.tag-item-text {
						font-family: Microsoft YaHei;
						font-size: 12px;
						font-weight: normal;
						font-stretch: normal;
						line-height: 19px;
						letter-spacing: 0px;
						display: inline-block;
						margin: 4px 12px;
					}

					.tag-item-01 {
						width: 72px;
						height: 24px;
						background-color: rgba(1, 71, 235, 0.2);

						.tag-item-text-01 {
							width: 48px;
							height: 16px;
							color: #0147eb;
						}
					}

					.tag-item-02 {
						width: 72px;
						height: 24px;
						background-color: rgba(98, 126, 234, 0.2);

						.tag-item-text-02 {
							width: 48px;
							height: 16px;
							color: #627eea;
						}
					}

					.tag-item-03 {
						width: 72px;
						height: 24px;
						background-color: rgba(19, 180, 64, 0.2);

						.tag-item-text-03 {
							width: 48px;
							height: 16px;
							color: #13b440;
						}
					}

					.tag-item-04 {
						width: 96px;
						height: 24px;
						background-color: rgba(240, 68, 68, 0.2);

						.tag-item-text-04 {
							width: 72px;
							height: 16px;
							color: #f04444;
						}
					}

					.tag-item-05 {
						width: 72px;
						height: 24px;
						background-color: rgba(255, 104, 3, 0.2);

						.tag-item-text-05 {
							width: 48px;
							height: 16px;
							color: #ff6803;
						}
					}

					.tag-item-06 {
						width: 96px;
						height: 24px;
						background-color: rgba(247, 147, 26, 0.2);

						.tag-item-text-06 {
							width: 72px;
							height: 16px;
							color: #f7931a;
						}
					}

					.tag-item-07 {
						width: 72px;
						height: 24px;
						background-color: rgba(138, 58, 237, 0.2);

						.tag-item-text-07 {
							width: 48px;
							height: 16px;
							color: #8a3aed;
						}
					}
				}
			}

			.head-descriptions {
				padding: 0 40px;
				// margin-top: 20px;
			}
		}
	}

	.main {
		width: 100%;
		background-color: #ffffff;
		box-shadow: 0px 12px 23px 0px rgba(0, 0, 0, 0.05);
		border-radius: 16px;
		margin-top: 16px;
		padding: 24px;
		box-sizing: border-box;


		.main-title {
			font-family: Microsoft YaHei;
			font-size: 24px;
			font-weight: normal;
			font-stretch: normal;
			line-height: 41px;
			letter-spacing: 1px;
			color: #24262b;
		}

		.btn {
			height: 32px;
			padding: 0 10px;
			box-sizing: border-box;
		}

		.btn-plus {
			background-color: #0147eb;
		}

		.pane-titlt {
			height: 85px;
			background-color: #f5f6fa;
			border-radius: 8px;
			padding: 30px 40px 10px;
			box-sizing: border-box;

			.time {
				font-size: 16px;
				color: #f04444;
				margin: 0 10px;
			}
		}

		.pane-content {
			.content-item {
				.item-title {
					// width: 40%;
					font-size: 16px;
					line-height: 24px;
					color: #24262b;
					margin: 20px 0;
				}

				.item-cont {
					font-size: 14px;
					line-height: 24px;
					color: #24262b;
					margin: 4px 32px;
					display: flex;
					justify-content: space-between;

					.cont-right {
						width: 500px;
						display: flex;
						justify-content: space-between;
						align-items: center;



						.right-item {
							font-size: 14px;
							color: #545454;
							height: 30px;
							line-height: 30px;
							padding: 0 20px;
							box-sizing: border-box;
							background-color: #ffffff;
							border-radius: 4px;
							border: solid 1px #c4c4c4;
							position: relative;

							.checkImg {
								position: absolute;
								right: 0;
								bottom: 0;
								width: 20px;
								height: 18px;
							}
						}

						.conform {
							border-radius: 4px;
							border: solid 1px #0147eb;
							color: #0147eb;
						}

						.unConform {
							background-color: #ffffff;
							border: solid 1px #f04444;
							color: #f04444;
						}

						.el-input {
							width: 260px;
							height: 32px;
						}

						/deep/.el-input__inner {
							height: 32px !important;
						}
					}
				}
			}

			.conclusion {
				font-size: 20px;
				line-height: 24px;
				// font-weight: bold;
				color: #24262b;

				.conclusion-box {
					display: flex;
					padding: 32px;
					box-sizing: border-box;

					div:nth-child(1) {
						height: 32px;
						background-color: #ffffff;
						border-radius: 4px;
						border: solid 1px #c4c4c4;
						font-size: 14px;
						line-height: 32px;
						padding: 0 20px;
						color: #545454;
						box-sizing: border-box;
						margin-right: 8px;
					}

					div:nth-child(2) {
						height: 32px;
						background-color: #ffffff;
						border-radius: 4px;
						border: solid 1px #f04444;
						font-size: 14px;
						line-height: 32px;
						padding: 0 20px;
						box-sizing: border-box;
						color: #f04444;
					}
				}
			}
		}

	}
</style>
